/**
 * widget-tablea-wynikow
 */
/* global ajaxurl Cookies TimelineMax Power1 theme ScrollMagic TweenMax */

import Calendar from './calendar.js';

(function($) {
    var wtb = {
        
        calendar: null,
        twt: null,
        loader: null,
        tl: null,
        
        init: () => {
            wtb.twt = $('#tabela-wynikow .tw-table');
            wtb.loader = $('#tabela-wynikow  #tw-loading');
            if(!$('#kalendarz-wynikow-content').length) return;
            wtb.tl = new TimelineMax({autoRemoveChildren: true});
            $('#tw-kategoria').change(wtb.changeKategoria);
            $('#tw-grupa').change(wtb.changeGrupa);
            $('body').append($('#resultMatchesModal').detach());
            $('#showModalResultTable').on('click', function(e) {
                e.preventDefault();
                $('#resultMatchesModal').modal();
            });

            new ScrollMagic.Scene({ offset: 250, 
                    triggerHook: 'onEnter', 
                    triggerElement: '#tabela-wynikow'
                })
                .setTween( TweenMax.staggerFromTo( $('#tabela-wynikow').find('h2, .info, select').add('#tw-content'), 1, 
                                { left: '-70%', opacity: 0 }, { left: '0', opacity: 1 }, 0.2 ) 
                            )
                .addTo(theme.scrollController);
        
            new ScrollMagic.Scene({ offset: 250, 
                    triggerHook: 'onEnter', 
                    triggerElement: '#kalendarz-wynikow-content'
                })
                .setTween( TweenMax.fromTo( $('#kalendarz-wynikow-content'), 1, 
                                { right: '-100%', opacity: 0 }, { left: '0', opacity: 1 } ) 
                            )

                .addTo(theme.scrollController);
        
            wtb.calendar = new Calendar('#kalendarz-wynikow-content > .outer', []);
        },
        
        changeKategoria: () => {
            wtb.hide();
            var kategoriaId = $('#tw-kategoria').val();
            Cookies.set('tw-kategoria', kategoriaId);
            
            $.ajax({
                url: ajaxurl,
                type: 'GET',
                data: {
                    action: 'getTabelaWynikow',
                    kategoria_id: kategoriaId
                },
                success: wtb.update
            });
        },
        
        changeGrupa: () => {
            wtb.hide();
            var kategoriaId = $('#tw-kategoria').val(),
                grupaId = $('#tw-grupa').val();
            Cookies.set('tw-kategoria', kategoriaId);
            
            $.ajax({
                url: ajaxurl,
                type: 'GET',
                data: {
                    action: 'getTabelaWynikowByGrupa',
                    kategoria_id: kategoriaId,
                    grupa_id: grupaId
                },
                success: wtb.update
            });
        },
        
        update: (data) => {
            $('#tw-grupa').html(data.grupy_options);
            var oldH = wtb.twt.parent().outerHeight();
            wtb.tl.call( () => {
                wtb.twt.find('>.table-wrapper').html(data.resultsTable);
                wtb.loader.removeClass('show');
                $('#resultMatchesModal .modal-body').html(data.resultsTable + data.tableMatches);
                var h = $('#resultMatchesModal .modal-title');
                h.html($('#tw-kategoria option:selected').text() + ' ' + $('#tw-grupa option:selected').text());
                Cookies.set('tw-grupa', $('#tw-grupa').val());
            }).set(wtb.twt.parent(), {height: 'auto'})
                .set(wtb.twt, { opacity: 0, scale: 0, right: 'auto', left: '-50' } )
                .from(wtb.twt.parent(), 0.5, { height: oldH })
                .to(wtb.twt, 0.3, { opacity: 1 }, "-=.2" )
                .fromTo(wtb.twt, 0.7, { rotationY: 90 },
                            { rotationY: 0, scale: 1, left: 0, ease: Power1.easeOut, transformOrigin: "left center center" }, "-=.2")
            ;
        },
        
        hide: () => {
            wtb.loader.addClass('show');
            wtb.tl.set(wtb.twt, { left: 'auto', right: 0 })
                .to(wtb.twt, 0.8, { 
                    scale: 0, 
                    rotationY: -90,
                    transformOrigin: "right center center",
                    ease: Power1.easeIn })
                .to(wtb.twt, 0.6, { right: '-50%', ease: Power1.easeIn }, '-=.6');
        }
    };
    
    $(document).ready(function() {
        wtb.init();
    });
})(jQuery);
